import { Dispatch } from "redux";
import { SalaryAction, SalaryActionTypes } from "../../types/salary";
import {TransfersAction, TransfersActionTypes} from "store/types/transfers";
import {getTrannsferByIban} from "../../../services/Transfers/transfers";
import {secureLocalStorageSet} from "../../../helpers";
import {getSalaryList, getSalaryListWithPin} from "../../../services/salary";
import {LoginAction, LoginActionTypes} from "store/types/login";
import {changeRoute} from "store/actions/login";

export const setTableDataSalary = (value:Array<any>) => {
    return (dispatch: Dispatch<SalaryAction>) => {
      dispatch({
        type: SalaryActionTypes.FILL_TABLE,
        payload: value
      })
    }
  }
  export const editTableDataSalary = (value:Array<any>) => {
    return (dispatch: Dispatch<SalaryAction>) => {
      dispatch({
        type: SalaryActionTypes.EDIT_TABLE,
        payload: value
      })
    }
  }
  export const setSelectedOption = (selectedItem:Array<any>) => {    
    return (dispatch: Dispatch<SalaryAction>) => {
      dispatch({
        type: SalaryActionTypes.SET_OPTION,
        payload: selectedItem
      })
    }
  }

  export const createTransferSalary = (value:Array<any>) => {
    return (dispatch: Dispatch<SalaryAction>) => {
      dispatch({
        type: SalaryActionTypes.CREATE_TRANSFER,
        payload: value
      })
    }
  }

export const getSalaryListFunc = (cif: String) => {
  return (dispatch: Dispatch<SalaryAction>) => {
    return new Promise(() => {
      dispatch({ type: SalaryActionTypes.GET_SALARY_LIST })
      getSalaryList(cif)
          .then((response:any) => {
            dispatch({
              payload: response,
              type: SalaryActionTypes.GET_SALARY_LIST_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              type: SalaryActionTypes.GET_SALARY_LIST_ERROR,
            })
            // Notify(error.response.data.messages[0].MESSAGE)
          })
    })
  }
}

export const getSalaryListWithPinFunc = (cif: String, pin: String) => {
  return (dispatch: Dispatch<SalaryAction>) => {
    return new Promise(() => {
      dispatch({ type: SalaryActionTypes.GET_SALARY_LIST_WITH_FIN })
      getSalaryListWithPin(cif, pin)
          .then((response:any) => {
            dispatch({
              payload: response,
              type: SalaryActionTypes.GET_SALARY_LIST_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              type: SalaryActionTypes.GET_SALARY_LIST_ERROR,
            })
            // Notify(error.response.data.messages[0].MESSAGE)
          })
    })
  }
}


export const clearSalaryListFunc = () => {
  return (dispatch: Dispatch<SalaryAction>) => {
    dispatch({
      type: SalaryActionTypes.CLEAR_SALARY_LIST
    })
  }
}




